<template>
  <div class="main-wrap">
    <div id="main-content" style="margin:0">
      <div class="wrapper">
        <jm-crumbs />

        <jm-toolbar ref="toolbarvm" customize-field-name="TrainingCustomer" show-defined-search show-defined-list>
          <router-link
            v-if="(!$hasPermission([92, 164], true) && [798389].indexOf(userInfo.userid) === -1) && isTrainingSite"
            slot="beforeDefinedSearch" class="button-search" target="_blank" :to="{ name: 'addCustomer' }">
            <el-button type="primary" size="medium">添加</el-button>
          </router-link>
          <a slot="beforeDefinedSearch" class="button-search" href="resourceImport"
             v-if="!$hasPermission([80, 164, 92], true) && isTrainingSite">
            <el-button type="primary" size="medium">资源导入</el-button>
          </a>
          <el-button v-show="false" size="medium" slot="afterDefinedSearch" type="success">导出</el-button>
          <router-link v-permission="[85, 91, 139]" v-if="isTrainingSite" target="_blank" class="button-search"
                       slot="beforeDefinedSearch" :to="{ name: 'resourceChange' }">
            <el-button type="primary" size="medium">资源变更记录</el-button>
          </router-link>
          <!--批量同步 角色：考培总监，用户：李明君管理2964795 袁兵强管理3164315-->
          <router-link target="_blank" v-if="($hasPermission([1, 91])|| [2964795, 3164315].indexOf(userInfo.userid) > -1) && isTrainingSite" class="button-search"
                       slot="beforeDefinedSearch" :to="{ name: 'resourceList' }">
            <el-button type="primary" size="medium">批量同步</el-button>
          </router-link>
          <router-link v-permission="[1, 91]" v-if="isTrainingSite" target="_blank" class="button-search"
                       slot="beforeDefinedSearch" :to="{ name: 'resourceChangeTeacher' }">
            <el-button type="primary" size="medium">修改咨询</el-button>
          </router-link>
        </jm-toolbar>

        <div class="table-agile-info">
          <div class="common-new-title mode2">
            <span>资源列表</span>
          </div>
          <div class="input-area none-month" @keyup.enter="inputAreaKeyup" v-if="!loadingDs">
            <div class="box-content" v-if="filterVisible('username')">
              <label class="form-tit">姓名</label>
              <el-input v-model.trim="searchData.username" class="jm-input175" />
            </div>
            <div class="box-content" v-if="filterVisible('nickname')">
              <label class="form-tit">昵称</label>
              <el-input v-model.trim="searchData.nickname" class="jm-input175" />
            </div>
            <div class="box-content" v-if="filterVisible('tel')">
              <label class="form-tit">电话</label>
              <el-input v-model.trim="searchData.tel" class="jm-input175" color="red" />
              <el-checkbox class="no-content-item" v-model="searchData['no_tel']">无</el-checkbox>
            </div>
            <div class="box-content" v-if="filterVisible('tel_province')">
              <label class="form-tit">手机号归属地</label>
              <el-select v-model="searchData.phoneProvince" filterable class="jm-input135" clearable placeholder="请选择"
                         @change="changePhoneProvince">
                <el-option v-for="item in phoneOwnership.provinces" :label="item" :value="item" :key="item" />
              </el-select>
              <el-select v-model="searchData.phoneCity" filterable class="jm-input135" clearable placeholder="请选择">
                <el-option v-for="item in phoneOwnership.cities" :label="item" :value="item" :key="item" />
              </el-select>
            </div>
            <div class="box-content" v-if="filterVisible('qq')">
              <label class="form-tit">QQ</label>
              <el-input v-model.trim="searchData.qq" class="jm-input175" />
              <el-checkbox class="no-content-item" v-model="searchData['no_qq']">无</el-checkbox>
            </div>
            <div class="box-content" v-if="filterVisible('wechat')">
              <label class="form-tit">微信</label>
              <el-input v-model.trim="searchData.wechat" class="jm-input175" />
              <el-checkbox class="no-content-item" v-model="searchData['no_wechat']">无</el-checkbox>
            </div>
            <div class="box-content" v-if="filterVisible('take_wechat')">
              <label class="form-tit">已添加微信</label>
              <jm-dict-select class="jm-input220" clearable v-model="searchData.take_wechat" dict="dataset.student.isHand" />
            </div>
            <div class="box-content" v-if="filterVisible('hand')">
              <label class="form-tit">是否主动添加</label>
              <jm-dict-select class="jm-input220" clearable v-model="searchData.hand" dict="dataset.student.isHand" />
            </div>
            <div class="box-content" v-if="filterVisible('identity')">
              <label class="form-tit">用户身份</label>
              <jm-identity-select clearable v-model="searchData.identity"/>
            </div>
            <div class="box-content" v-if="filterVisible('customer_status')">
              <label class="form-tit">客户状态</label>
              <jm-dict-select v-model="searchData.customer_status" class="jm-input135" clearable type="dataset"
                              dict-type="training" name="trainingLevelType" />
              <jm-dict-select v-model="searchData.diff_type" class="jm-input135" clearable type="dataset" dict-type="training" name="diffType" :disabled="infoReadonly" v-if="followpUp"/>
              <el-checkbox class="no-content-item" v-model="searchData['no_select_diff']" v-if="followpUp">无异议</el-checkbox>
            </div>
            <div class="box-content" v-if="filterVisible('customer_classify')">
              <label class="form-tit">意向分级</label>
              <jm-dict-select v-model="searchData.customer_classify" clearable class="jm-input135" type="dataset"
                              dict-type="training" name="trainingLvType" />
            </div>
            <div class="box-content" v-if="filterVisible('sale_proc')">
              <label class="form-tit">销售进程</label>
              <jm-dict-select class="jm-input220" clearable v-model="searchData.sale_proc" dict="dataset.training.saleProc" />
            </div>
            <div class="box-content" v-if="filterVisible('call_status')">
              <label class="form-tit">外呼状态</label>
              <el-select v-model="searchData.call_status" class="jm-input-common" clearable placeholder="请选择">
                <el-option v-for="item in callStatus" :label="item.label" :value="item.value" :key="item.value" />
              </el-select>
            </div>
            <div class="box-content" v-if="filterVisible('sign_date')">
              <label class="form-tit">签约日期</label>
              <el-date-picker :editable="false" v-model="searchData.sign_date" type="daterange" unlink-panels
                              placeholder="选择日期" value-format="yyyy-MM-dd" class="jm-input280" />
            </div>
            <div class="box-content" v-if="filterVisible('training_teacher')">
              <label class="form-tit">咨询老师</label>
              <el-select v-model="searchData.training_teacher" class="jm-input220" clearable placeholder="请选择"
                         filterable color="red">
                <el-option-group v-for="(group, k) in ds.training_teacher" :key="k" :label="k">
                  <el-option v-for="item in group" :key="`${item.country}_${item.userid}`" :label="item.truename"
                             :value="item.userid" />
                </el-option-group>
              </el-select>
            </div>
            <div class="box-content" v-if="filterVisible('creator')">
              <label class="form-tit">创建人</label>
              <el-select v-model="searchData.creator" filterable class="jm-input135" clearable placeholder="请选择">
                <el-option-group v-for="(group, k) in ds.create_person" :key="k" :label="k">
                  <el-option v-for="item in group" :key="item.userid" :label="item.username" :value="item.userid" />
                </el-option-group>
              </el-select>
              <el-checkbox class="no-content-item" v-model="searchData.exclude_self">排除自己</el-checkbox>
            </div>
            <div class="box-content" v-if="filterVisible('create_point')">
              <label class="form-tit">采集功能</label>
              <el-select v-model="searchData.create_point" filterable class="jm-input280" clearable multiple
                         placeholder="请选择" color="red">
                <el-option v-for="item in createPersonZZ" :key="item.userid" :label="item.username"
                           :value="item.userid" />
              </el-select>
              <el-checkbox class="no-content-item" v-model="searchData.create_point_ex">排除</el-checkbox>
            </div>

            <div class="box-content" v-if="filterVisible('custom_promoter')">
              <label class="form-tit">推广人</label>
              <el-select v-model="searchData.custom_promoter" filterable class="jm-input280" clearable multiple
                         placeholder="请选择">
                <el-option-group v-for="(group, k) in ds.create_person" :key="k" :label="k">
                  <el-option v-for="item in group.filter(item => item.userid > 0)" :key="item.userid"
                             :label="item.username" :value="item.userid" />
                </el-option-group>
              </el-select>
              <el-checkbox class="no-content-item" v-model="searchData.custom_promoter_ex">排除</el-checkbox>
            </div>
            <div class="box-content" v-if="filterVisible('target_lan')">
              <label class="form-tit">意向语言</label>
              <el-select v-model="searchData.target_lan" class="jm-input-common" multiple clearable placeholder="请选择">
                <el-option v-for="item in trainingTargetLan" :label="item.label" :value="item.value" :key="item.value" />
              </el-select>
            </div>
            <div class="box-content" v-if="filterVisible('create_time')">
              <label class="form-tit">创建日期</label>
              <el-date-picker v-model="searchData.create_time" type="daterange" unlink-panels placeholder="选择日期"
                              value-format="yyyy-MM-dd" class="jm-input280" />
            </div>
            <div class="box-content" v-if="filterVisible('change_teacher_time')">
              <label class="form-tit">分配咨询时间</label>
              <el-date-picker v-model="searchData.change_teacher_time" type="daterange" unlink-panels placeholder="选择日期"
                              value-format="yyyy-MM-dd" class="jm-input280" />
            </div>
            <div class="box-content" v-if="filterVisible('visit_date')">
              <label class="form-tit">回访日期</label>
              <el-date-picker v-model="searchData.visit_date" :editable="false" type="daterange" unlink-panels
                              placeholder="选择日期" value-format="yyyy-MM-dd" class="jm-input280" />
            </div>
            <div class="box-content" v-if="filterVisible('visit_count')">
              <label class="form-tit">回访次数</label>
              <el-input v-model="searchData.visit_count1" class="jm-input90" />
              <em>至</em>
              <el-input v-model="searchData.visit_count2" class="jm-input90" />
            </div>
            <div class="box-content box-content-double" v-if="filterVisible('channels')">
              <label class="form-tit">渠道来源</label>
              <jm-channel v-model="searchData.channels" clearable filterable />
            </div>
            <div class="box-content" v-if="filterVisible('id')">
              <label class="form-tit">客户编码</label>
              <el-input v-model="searchData.id" class="jm-input175" />
            </div>
            <div class="box-content" v-if="filterVisible('ai_tag')">
              <label class="form-tit">AI外呼反馈</label>
              <el-select v-model="searchData.ai_tag" class="jm-input-common" multiple clearable placeholder="请选择">
                <el-option v-for="item in trainingAiTag" :label="item.label" :value="item.value" :key="item.value" />
              </el-select>
            </div>
            <div class="box-content" v-if="filterVisible('ai_tag_time')">
              <label class="form-tit">AI外呼时间</label>
              <el-date-picker v-model="searchData.ai_tag_time" type="daterange" unlink-panels placeholder="选择日期" value-format="yyyy-MM-dd" class="jm-input280" />
            </div>
            <div class="box-content" v-if="filterVisible('phone_brand')">
              <label class="form-tit">手机品牌</label>
              <el-select v-model="searchData.phone_brand" class="jm-input-common" clearable placeholder="请选择">
                <el-option v-for="item in phoneBrand" :label="item.label" :value="item.value" :key="item.value" />
              </el-select>
            </div>
            <div class="box-content" v-if="filterVisible('create_type')">
              <label class="form-tit">创建类型</label>
              <jm-dict-select v-model="searchData.create_type" clearable class="jm-input135"
                              dict="dataset.training.createType" />
            </div>
            <div class="box-content" v-if="filterVisible('target_country')">
              <label class="form-tit">意向部门</label>
              <el-select v-model="searchData.target_country" placeholder="请选择" clearable>
                <el-option :key="1" :value="1868" label="考培" />
                <!-- <el-option :key="2" :value="2044" label="英澳培训" /> -->
                <!-- <el-option :key="3" :value="1944" disabled label="高考日语线上" /> -->
                <!-- <el-option :key="4" :value="2043" disabled label="高考日语线下" /> -->
              </el-select>
            </div>

            <div class="box-content" v-if="filterVisible('check_ocean_count')">
              <label class="form-tit">进入公海次数</label>
              <jm-dict-select v-model="searchData.check_ocean_count" type="training" dict-type="check_ocean_count"
                              clearable filterable />
            </div>
            <div class="box-content" v-if="filterVisible('check_ocean_time')">
              <label class="form-tit">公海分配时间</label>
              <el-date-picker v-model="searchData.check_ocean_time" :editable="false" type="daterange" unlink-panels
                              placeholder="选择日期" value-format="yyyy-MM-dd" class="jm-input280" />
            </div>

            <div class="box-content" v-if="filterVisible('activity_code')">
              <label class="form-tit">活动编码</label>
              <el-input v-model="searchData.activity_code" class="jm-input175" />
            </div>

            <div class="box-content" v-if="filterVisible('is_default_visit') && this.$hasPermission([1])">
              <label class="form-tit">非默认回访</label>
              <el-switch active-text="筛选" inactive-text="不筛选" :active-value="1" :inactive-value="0" class="jm-input135"
                         v-model="searchData.is_default_visit" />
            </div>

            <div class="box-content" v-if="filterVisible('is_im_push') && this.$hasPermission([1, 62, 84])">
              <label class="form-tit">查询客服下发</label>
              <el-switch active-text="筛选" inactive-text="不筛选" :active-value="1" :inactive-value="0" class="jm-input135"
                         v-model="searchData.is_im_push" />
            </div>

            <div class="box-content" v-if="filterVisible('people_grant_time') && this.$hasPermission([1, 62, 84])">
              <label class="form-tit">手动下发时间</label>
              <el-date-picker v-model="searchData.people_grant_time" type="daterange" unlink-panels placeholder="选择日期"
                              value-format="yyyy-MM-dd" class="jm-input280" />
            </div>

            <div class="box-content" v-if="filterVisible('snapshot_create_point')">
              <label class="form-tit">重复进入采集功能</label>
              <el-select v-model="searchData.snapshot_create_point" filterable class="jm-input280" clearable multiple
                         placeholder="请选择">
                <el-option v-for="item in createPersonZZ" :key="item.userid" :label="item.username"
                           :value="item.userid" />
              </el-select>
            </div>
            <div class="box-content" v-if="filterVisible('op_teacher')">
              <label class="form-tit">用户运营老师</label>
              <el-select v-model="searchData.op_teacher" class="jm-input220" filterable clearable placeholder="请选择">
                <el-option-group v-for="(group, k) in ds.op_teacher" :key="k" :label="k">
                  <el-option v-for="item in group" :key="item.userid" :label="item.truename" :value="item.userid" />
                </el-option-group>
              </el-select>
            </div>
            <div class="box-content" v-if="filterVisible('introducer_id')">
              <label class="form-tit">介绍人编码</label>
              <el-input v-model="searchData.introducer_id" class="jm-input175" />
            </div>

            <div class="box-content" v-if="filterVisible('introducer_status')">
              <label class="form-tit">是否是被介绍人</label>
              <jm-dict-select class="jm-input175" clearable v-model="searchData.introducer_status"
                              dict="dataset.student.introducerStatus" />
            </div>
            <div class="jm-primary">
              <el-button type="primary" @click="() => { this.refresh = true; }">开始查询</el-button>
              <el-button type="" @click="initSearchData()">
                清空条件
              </el-button>
              <el-button type="success" v-if="isTrainingSite" :loading="exporting"
                         @click="snapshotExport">
                重复资源导出
              </el-button>
              <el-button v-if="!isTrainingSite" :disabled="!canSearch" type="danger" @click="showSyncDialog">
                批量同步到昆仑
              </el-button>
              <!-- <el-button
            v-if="$hasPermission('export_visit_0')"
            :disabled="!canSearch"
            type="primary"
            :loading="exporting">导出回访记录</el-button>-->
              <!-- <el-button
            v-if="$hasPermission([30, 62])"
            type="primary" >
            <router-link
              target="_blank"
              :to="{ name: 'snapshot' }"
            >重复资源记录管理</router-link>
            </el-button>-->
              <!-- <el-button :disabled="!canSearch" type="warning">批量同步到蓝火</el-button> -->
            </div>
          </div>

          <jm-tableList ref="stable" :url="pageTabelUrl()" :search-data="searchData" :refresh.sync="refresh"
                        row-key="id">
            <el-table-column slot="username" slot-scope="scope" v-bind="scope.attrs" :label="scope.label" property="id">
              <template slot-scope="scope">
                <el-tag v-for="link in scope.row.link_others" :key="link.id">{{ getSiteTagByType(link.sync_type)
                }}</el-tag>
                <router-link
                  v-if="((!scope.row.is_other && $hasPermission([1, 52, 80, 81, 85, 91, 84, 106, 137, 139, 89])) || $hasPermission(117, 165, 164) || ($hasPermission(97) && scope.row.creator_uid === userInfo.userid)) && isTrainingSite"
                  target="_blank" :class="scope.row.customer_status === 13 ? 'red' : 'blue'"
                  :to="{ name: 'resourceEdit', params: { id: scope.row.id } }">
                  {{ scope.row.username }} {{ scope.row.nickname ? `/ ${scope.row.nickname}` : '' }}
                </router-link>
                <span v-else>
                  {{ scope.row.username }} {{ scope.row.nickname ? `/ ${scope.row.nickname}` : '' }}
                </span>
              </template>
            </el-table-column>
            <el-table-column slot="limit_visit_time" slot-scope="scope" :label="scope.label"
                             property="limit_visit_time">
              <template slot-scope="scope">
                <span style="font-weight: bold; color: red;">{{ scope.row.limit_visit_time }}</span>
              </template>
            </el-table-column>
            <!--用户运营最后回访-->
            <el-table-column slot="operate_last_time" slot-scope="scope" v-bind="scope.attrs" :label="scope.label"
                             property="operate_last_time">
              <template slot-scope="scope">
                <div class="box">
                  <div class="top">
                    <el-tooltip placement="top-start">
                      <div slot="content">
                        <div style="max-width:400px" v-text="scope.row.operate_last_str"></div>
                      </div>
                      <p>{{ scope.row.operate_last_time }}</p>
                    </el-tooltip>
                  </div>
                </div>
              </template>
            </el-table-column>
            <!--回访记录-->
            <el-table-column slot="visit_log" slot-scope="scope" v-bind="scope.attrs" :label="scope.label" property="id">
              <template slot-scope="scope">
                <span v-html="(scope.row.visit_log||'').replace(/\n/g, '<br>')"></span>
              </template>
            <!--<template slot-scope="scope">
            <div class="box">
              <div class="top">
                <el-tooltip placement="top-start">
                  <div slot="content">
                    <div style="max-width:400px" v-text="scope.row.visit_log"></div>
                  </div>
                  <p>{{ scope.row.visit_log|filterFun }}</p>
                </el-tooltip>
              </div>
            </div>
          </template> -->
            </el-table-column>
            <el-table-column fixed="right" slot="lastColumn" label="操作" v-if="isTrainingSite" :min-width="400"
                             class-name="scope-button-list">
              <template slot-scope="scope">
                <el-row>
                  <el-button v-if="!readOnlyTraining && !isMasterTrainingTeacher(scope.row.training_teacher)"
                             size="mini" type="success">
                    <a target="_blank" :href="`https://www.jiemo.net/live/bill/report?uuid=${scope.row.uuid}`">报名表</a>
                  </el-button>
                  <router-link target="_blank"
                               v-if="(!scope.row.is_other && $hasPermission([52, 80, 137, 139])) || $hasPermission([81, 84, 85, 89, 91, 92, 97, 106, 117, 154,155,160, 164, 165])"
                               :to="{ name: 'resourceEdit', params: { id: scope.row.id } }">
                    <el-button size="mini" type="primary">{{ readOnlyTraining ||
                      isMasterTrainingTeacher(scope.row.training_teacher) || $hasPermission([89, 97, 106, 117, 154,
                                                                                             160], true) ? '查看' : '编辑' }}</el-button>
                  </router-link>
                  <el-button
                    v-if="!readOnlyTraining && !isMasterTrainingTeacher(scope.row.training_teacher) && !$hasPermission([80, 164],true)"
                    size="mini" type="warning"
                    @click="visitHandle({ crmid: scope.row.id }, 'appointment', '预约回访')">预约</el-button>
                  <el-button v-if="!readOnlyTraining && !isMasterTrainingTeacher(scope.row.training_teacher)"
                             size="mini" type="success"
                             @click="visitHandle({ crmid: scope.row.id }, 'visit', '快捷回访')">回访</el-button>
                  <el-button v-if="false && (scope.row.custom_promoter_int === userInfo.userid || $hasPermission([117])) "
                             size="mini" type="primary" @click="openReuse(scope.row)">资源复用
                  </el-button>
                </el-row>
              </template>
            </el-table-column>
          </jm-tableList>
        </div>
      </div>
    </div>

    <!--资源复用弹窗(这个功能考培这边不用，暂时取消)-->
    <el-dialog width="600px" title="资源复用" :visible.sync="reuseLock">
      <el-row style="margin-bottom: 10px">
        <el-col :span="3" class="jm-tar" style="line-height: 35px">复用系统</el-col>
        <el-col :span="18" style="margin-left: 10px">
          <jm-dict-select class="jm-input-common" :filter="(item) => item.id !== reuseForm.origin_tag" clearable
                          type="jiemo" dict-type="site_name" name="site_name" value-type="String" v-model="reuseForm.target_tag" />
        </el-col>
      </el-row>
      <el-row style="margin-bottom: 10px">
        <el-col :span="3" class="jm-tar" style="line-height: 35px">复用备注</el-col>
        <el-col :span="18" style="margin-left: 10px">
          <el-input type="textarea" :rows="5" placeholder="请输入内容" v-model="reuseForm.memo" resize="none">
          </el-input>
        </el-col>
      </el-row>
      <el-row style="margin-bottom: 10px">
        <el-col :span="3" class="jm-tar" style="line-height: 35px">上传截图</el-col>
        <el-col :span="18" style="margin-left: 10px">
          <jm-upload class="reuse-uploader" action="/newfib.php/index/api_base/uploadSimpleFile/type/reuse"
                     :show-file-list="false" :on-success="handleReuseSuccess" :before-upload="beforeReuseUpload">
            <img v-if="reuseForm.url" :src="reuseForm.url" class="reuse-img">
            <i v-else class="el-icon-plus reuse-uploader-icon"></i>
          </jm-upload>
        </el-col>
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeReuse">取 消</el-button>
        <el-button type="primary" @click="saveReuse">确 定</el-button>
      </span>
    </el-dialog>
    <!--快捷回访 预约回访 父层组件-->
    <jm-visit-form-dialog :visible.sync="visitVisible" :title="visitDialogTitle" :type="visitType"
                          :data-set="visitData" />
    <!--批量拉取-->
    <el-dialog width="30%" title="选择考培咨询" :visible.sync="syncToFibDialog">
      <el-select v-model="sync.teacher" class="jm-input-common" clearable placeholder="请选择">
        <el-option-group key="auto" label="Auto">
          <el-option label="自动分配" value="-1" />
        </el-option-group>
      </el-select>
      <el-row>
        <el-col>同步到意向国家</el-col>
      </el-row>
      <el-select v-model="sync.country">
        <el-option v-for="item in syncToHopeCountries" :label="item.value" :key="item.id" :value="item.id" />
      </el-select>
      <span slot="footer" class="dialog-footer">
        <el-button @click="() => { syncToFibDialog = false; }">取 消</el-button>
        <el-button type="primary" :disabled="sync.country === ''" @click="batchSyncToFib">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import '@/assets/css/index.css';
import toolbar from '@/components/tool/toolbar.vue';
import tableList from '@/components/data/tableList.vue';
import visitFormDialog from '@/components/tool/visitFormDialog.vue';
import { filterVisible, getSiteTagByType } from '@/utils/utils';
import {
  jmAreaselect,
  jmChannel,
  jmDictSelect,
  jmEducationSelect,
  jmExamjpSelect,
  jmLessonSelect,
  jmIdentitySelect
} from '@/components/tool';
import student from '@/pages/student/student';
import { targetLan, trainingAiTag, phoneBrand, callStatus } from '@/dataset/training';

let defaultSearchData = {
  customer_status: '',
  channels: {
    custom_from: '',
    custom_from_sub: '',
    custom_from_thrid: '',
    custom_from_fourth: '',
    custom_from_fifth: ''
  },
  exclude_self: false,
  custom_promoter_ex: false,
  custom_promoter: [],
  create_point_ex: false,
  create_point: [],
  sign_lesson_index: {},
  no_qq: false,
  no_wechat: false,
  no_tel: false,
  phoneCity: '',
  is_default_visit: '0',
  is_im_push: '0',
  target_lan: [],
  ai_tag: [],
};

export default {
  name: 'ResourceManager',
  mixins: [student],
  data() {
    return {
      trainingTargetLan: targetLan,
      trainingAiTag: trainingAiTag,
      phoneBrand: phoneBrand,
      callStatus: callStatus,
      refresh: false,
      exporting: false,
      searchData: {},
      syncToFibDialog: false,
      followpUp: false, // 是否跟进
      sync: {
        teacher: '-1',
        country: ''
      },
      phoneOwnership: {
        area: {},
        provinces: [],
        cities: []
      },
      reuseLock: false, // 资源复用弹窗锁
      reuseForm: {
        origin_tag: process.env.VUE_APP_SITE_NAME,
        origin_id: '',
        target_tag: '',
        memo: '',
        path: '',
        url: '',
      }, // 资源复用表单
      moreSearch: false, // 展开更多搜索
    };
  },
  components: {
    'jm-toolbar': toolbar,
    'jm-tableList': tableList,
    jmAreaselect,
    jmVisitFormDialog: visitFormDialog,
    jmChannel,
    jmLessonSelect,
    jmEducationSelect,
    jmDictSelect,
    jmExamjpSelect,
    jmIdentitySelect,
  },
  filters: {
    filterFun: function (value) {
      if (value && value.length > 10) {
        value = `${value.substring(0, 10)}...`;
      }
      return value;
    },
  },
  methods: {
    // 搜索区域显隐
    searchHidden() {
      this.moreSearch = !this.moreSearch;
    },
    // 资源复用相关
    openReuse(row) {
      this.reuseForm = {
        origin_tag: process.env.VUE_APP_SITE_NAME,
        origin_id: row.id,
        target_tag: '',
        memo: '',
        path: '',
        url: '',
      };
      this.reuseLock = true;
    },
    closeReuse() {
      this.reuseLock = false;
    },
    saveReuse() {
      if (!this.reuseForm.target_tag) {
        this.$message.error('请选择系统');
        return false;
      }
      if (!this.reuseForm.memo) {
        this.$message.error('请填写备注');
        return false;
      }
      if (!this.reuseForm.path) {
        this.$message.error('请上传截图');
        return false;
      }
      this.$http
        ._post({
          url: '/index/reuse/save',
          data: this.reuseForm
        })
        .then(() => {
          this.$message.success('保存成功');
        })
        .catch(() => {
          this.$message.error('保存失败');
        });
      this.closeReuse();
    },
    handleReuseSuccess(res) {
      this.reuseForm.path = res.data.path;
      this.reuseForm.url = res.data.url;
    },
    beforeReuseUpload(file) {
      const isJPG = file.type === 'image/jpeg' || file.type === 'image/png';
      const isLt2M = file.size / 1024 / 1024 < 1;

      if (!isJPG) {
        this.$message.error('上传图片只能是 JPG或PNG 格式');
      }
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 1MB');
      }
      return isJPG && isLt2M;
    },
    filterVisible,
    getSiteTagByType,
    initSearchData() {
      this.searchData = Object.assign({}, defaultSearchData);

      this.searchData.channels.custom_from = '';
      this.searchData.channels.custom_from_sub = '';
      this.searchData.channels.custom_from_thrid = '';
      this.searchData.channels.custom_from_fourth = '';
      this.searchData.channels.custom_from_fifth = '';
    },
    fetchCrmTelArea() {
      this.$http
        ._get({
          url: '/index/api_base/fetchCrmTelArea'
        })
        .then(({ data }) => {
          this.phoneOwnership.area = data;
          this.phoneOwnership.provinces = Object.keys(data);
        });
    },
    changePhoneProvince(v) {
      this.searchData.phoneCity = '';
      this.phoneOwnership.cities = this.phoneOwnership.area[v];
    },
    snapshotExport() {
      this.exporting = true;
      this.$http
        ._post({
          url: '/training/customer/snapshotExport',
          data: this.searchData
        })
        .then(({ data }) => {
          this.exporting = false;
          this.$http._download({
            filename: data,
            download: '考培资源重复记录.xlsx'
          });
        })
        .catch(() => {
          this.exporting = false;
          this.$message.error('可能数据太多了。。。');
        });
    },
    pageTabelUrl() {
      return this.isTrainingSite ? '/training/customer/pagetable' : '/index/student/trainingList';
    },
    showSyncDialog() {
      this.syncToFibDialog = true;
    },
    /**
     * 考培站点，批量同步资源到考培
     */
    batchSyncToFib() {
      this.$confirm('确认将所查资源信息批量同步到留学系统吗？', {
        type: 'warning',
      }).then(() => {
        this.doSyncingToFib();
      }).catch(() => {
        console.log('cancel sync');
      });
    },
    /**
     * 批量同步到昆仑
     */
    doSyncingToFib() {
      this.syncToFibDialog = false;
      const syncingMsg = this.$message({
        message: '同步中...',
        duration: 0
      });
      this.$http._post({
        url: '/index/student/batchSync',
        data: {
          searchData: this.searchData,
          teacherId: this.sync.teacher,
          country: this.sync.country
        }
      }).then(() => {
        syncingMsg.close();
        this.$message.success('同步成功！');
        this.refresh = true;
        this.sync.country = '';
      }).catch(() => {
        syncingMsg.close();
      });
    },
  },
  created() {
    this.initSearchData();
    this.getDatasource();
    this.fetchCrmTelArea();
  },
  mounted() {
  },
  computed: {
    syncToHopeCountries() {
      return this.hopeCountries.filter((item) => {
        return [2069, 1880, 1882, 1938, 1943, 1944, 2040, 2042, 2043, 2070, 1868, 2044, 675].indexOf(item.id) === -1;
      });
    },
    createPersonZZ() {
      if (this.ds.create_person && this.ds.create_person.ZZ) {
        return this.ds.create_person.ZZ.filter(item => item.userid < 0);
      }
      return [];
    },
  },
  watch: {
    // 客户状态
    'searchData.customer_status'(val) {
      if (val === 8 || val === 14) {
        this.followpUp = true;
      } else {
        this.followpUp = false;
      }
    },
    canSearch(value) {
      console.log(value);
      // if (value === false) {
      //   this.refresh = true;
      // }
    }
  }
};
</script>
<style scoped>
.box-content-double {
  width: 66.6% !important;
}
.box-content-double .el-checkbox__label {
  color: #f60;
}
.button-search {
  margin-right: 10px;
  display: inline-block;
  height: 100%;
}
.button-search:last-of-type {
  margin-left: 3px;
}

.box-content /deep/ .el-input > input[color=red] {
  color: #ff0000;
}
.box-content /deep/ .el-select[color=red] > .el-input > input {
  color: #ff0000;
}
.box-content /deep/ .el-select[color=red]  .el-tag--info  {
  color: #ff0000!important;
}

</style>
